import React, { Component } from 'react';
import BillingController from './billing.controller';
import withHooks from '../../core/withHooks';
import Inherit from '../../core/inherit';
import { Layout, Loading } from '../common';
import { DatePicker, Button, Checkbox } from 'antd';
import { CalendarOutlined, DownloadOutlined } from '@ant-design/icons';
import BillableKPIs from './elements/BillableKPIs';
import styles from './billing.module.scss';

const { RangePicker } = DatePicker;

class Billing extends Inherit(BillingController, Component) {
    state = {
        user: {},
        loading: true,
        kpiData: null,
        kpiLoaded: false,
        statements: [],
        statementsLoaded: false,
        dateRange: null,
        selectedStatements: new Set(),
    };

    render() {
        const {
            loading,
            kpiData,
            kpiLoaded,
            statements,
            statementsLoaded,
            user,
            dateRange,
            selectedStatements
        } = this.state;

        return (
            <Layout user={user} fi={user?.fi?.name}>
                <div className={styles.container}>
                    <div className={styles.header}>
                        <h1 className={styles.title}>Billing</h1>
                    </div>

                    <div className={styles.kpiSection}>
                        <h2 className={styles.sectionTitle}>Billable KPIs</h2>
                        <div className={styles.headerActions}>
                            <RangePicker
                                value={dateRange}
                                onChange={(dates) => this.handleDateChange(dates)}
                                suffixIcon={<CalendarOutlined />}
                                size="large"
                                className={styles.datePicker}
                            />
                            <Button
                                icon={<DownloadOutlined />}
                                className={styles.settingsButton}
                                size="large"
                            />
                        </div>
                    </div>

                    {kpiLoaded ? (
                        <BillableKPIs
                            enrolledUsers={kpiData?.enrolledUsers || 1000}
                            enrolledUsersChange={kpiData?.enrolledUsersChange || 20}
                            invoiceAmount={kpiData?.invoiceAmount || 3000}
                            invoiceAmountChange={kpiData?.invoiceAmountChange || 20}
                            nextInvoiceDue={kpiData?.nextInvoiceDue || 'Dec 30, 2025'}
                            nextInvoiceDueChange={kpiData?.nextInvoiceDueChange || 20}
                        />
                    ) : <Loading />}

                    <div className={styles.statementsSection}>
                        <div className={styles.statementsHeader}>
                            <h2 className={styles.sectionTitle}>Statements</h2>
                            <Button
                                type="text"
                                icon={<DownloadOutlined />}
                                onClick={() => this.exportToXLSX()}
                                className={styles.exportButton}
                                size="large"
                            >
                                Export as XLSX
                            </Button>
                        </div>

                        {statementsLoaded ? (
                            <div className={styles.tableContainer}>
                                <table className={styles.table}>
                                    <thead>
                                        <tr>
                                            <th className={styles.checkboxCell}>
                                                <Checkbox
                                                    checked={selectedStatements.size === statements.length && statements.length > 0}
                                                    indeterminate={selectedStatements.size > 0 && selectedStatements.size < statements.length}
                                                    onChange={() => this.handleSelectAll()}
                                                />
                                            </th>
                                            <th>Date</th>
                                            <th>Enrolled Users</th>
                                            <th>Invoice Amount</th>
                                            <th>Status</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {statements.map((statement) => (
                                            <tr key={statement.id}>
                                                <td className={styles.checkboxCell}>
                                                    <Checkbox
                                                        checked={selectedStatements.has(statement.id)}
                                                        onChange={() => this.handleSelectStatement(statement.id)}
                                                    />
                                                </td>
                                                <td className={styles.dateCell}>{statement.dateRange}</td>
                                                <td>{statement.enrolledUsers.toLocaleString()}</td>
                                                <td>${statement.invoiceAmount.toLocaleString('en-US', { minimumFractionDigits: 2 })}</td>
                                                <td>
                                                    <span className={`${styles.statusPill} ${styles[statement.status.toLowerCase()]}`}>
                                                        {statement.status}
                                                    </span>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        ) : <Loading />}
                    </div>
                </div>
            </Layout>
        );
    }
}

export default withHooks(Billing);

